import { type ClassValue, clsx } from 'clsx';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function useSetPageTitle(title: string) {
  useEffect(() => {
    document.title = title;
  }, [title]);
}

export const useAssertedParams = <T extends Record<string, string>>() => useParams() as T;
